export enum ContextType {
    /**
     * The application context.
     */
    DEFAULT = 'default',

    /**
     * IAP context
     */
    PURCHASE_PRODUCT = 'purchaseProduct',

    /**
     * Invite a friend.
     */
    INVITE_FRIEND = 'invite_friend',

    /**
     * Share beat highscore level with a friend.
     */
    SHARE_BEAT_HIGHSCORE_LEVEL = 'shareBeatHighscoreLevel',

    /**
     * Send coins to a friend.
     */
    SEND_CURRENCY = 'sendCurrency',

    /**
     * Send gift to a friend.
     */
    SEND_FRIEND_GIFT = 'sendFriendGift',

    /**
     * Send coins to a friend.
     */
    GIVE_CURRENCY = 'giveCurrency',

    /**
     * Request currency from a friend.
     */
    REQUEST_CURRENCY = 'requestCurrency',

    /**
     * Share a bot message with their friends.
     */
    SHARE_3_STAR_REWARD = 'share3StarReward',

    /**
     * Share a bot message with their friends.
     */
     SHARE_HARD_LEVEL = 'shareHardLevel',

     /**
     * Share a bot message with their friends.
     */
    SHARE_FARM = 'shareFarm',

    /**
     * Share a bot message with their friends.
     */
    SHARE_CROP_UNLOCKED = 'shareCropUnlocked',

    /**
     * Share a bot message with their friends.
     */
    SHARE_PET_UNLOCKED = 'sharePetUnlocked',

    /**
     * Share a bot message with their friends.
     */
    SHARE_FIELD_UNLOCK = 'shareFieldUnlock',
    /**
     * Watch an advertisement.
     */
    DISPLAY_ADVERTISEMENT = 'displayAdvertisement',

    /**
     * Share a screenshot of the game
     * data.message: The Message sent to the friend
     * data.payloadData: Payload data sent with it (for tracking)
     */
    SHARE_SCREENSHOT = 'shareScreenshot',

    /**
     * Request that the player subscribe the bot associated to the game.
     */
    SUBSCRIBE_BOT_OPT_IN = 'subscribeBotOptIn',

    /**
     * Request a life from a friend.
     */
    REQUEST_HELP = 'requestHelp',
}

export interface IContext {
    /**
     * The currently active context.
     */
    current: ContextType;

    /**
     * The payload sent to the new context.
     */
    request?: IContextRequest;

    /**
     * The response from the most recent context.
     */
    response?: IContextResponse;

    /**
     * Whether or not audio is enabled in the current context.
     */
    audioEnabled: boolean;
}

export interface IContextRequest {
    context: ContextType;
    data?: any;
}

export interface IContextResponse {
    responseType: ResponseType;
    status: ResponseStatus;
    data?: any;
}

export enum ResponseType {
    PURCHASE_PRODUCT = 'purchaseProduct',
    PLAY_WITH_FRIENDS = 'playWithFriends',
    INVITE_FRIEND = 'inviteFriend',
    SHARE_BEAT_HIGHSCORE_LEVEL = 'shareBeatHighscoreLevel',
    GIVE_CURRENCY = 'giveCurrency',
    SEND_CURRENCY = 'sendCurrency',
    SEND_FRIEND_GIFT = 'sendFriendGift',
    SHARE_CROP_UNLOCKED = 'shareCropUnlocked',
    SHARE_PET_UNLOCKED = 'sharePetUnlocked',
    SHARE_SCREENSHOT = 'shareScreenshot',
    REQUEST_CURRENCY = 'requestCurrency',
    SHARE_3_STAR_REWARD = 'share3StarReward',
    SHARE_FIELD_UNLOCK = 'shareFieldUnlock',
    DISPLAY_ADVERTISEMENT = 'displayAdvertisement',
    SUBSCRIBE_BOT_OPT_IN = 'subscribeBotOptIn',
    REQUEST_HELP = 'requestHelp',
    MY_PET_MINI_GAME_JACKPOT = 'myPetMiniGameJackpot',
    LUCKY_WHEEL_REWARD = 'luckyWheelReward',
    PREMIUM_WHEEL_REWARD = 'premiumWheelReward',
    SHARE_HARD_LEVEL = 'shareHardLevel',
    SHARE_FARM = 'shareFarm',
}

export enum ResponseStatus {
    SUCCESS = 'success',
    FAIL = 'fail',
}
